import {
  DropdownField,
  DropdownOptionItem,
  isDropdownOptionItem,
  TemplateFieldElement,
} from '@hb/shared'
import { useCallback, useMemo } from 'react'
import { Path, Transforms } from 'slate'
import { CustomEditor } from '../../../types/editor'
import { RadioFieldToolbarControls } from './RadioFieldToolbarControls'

// Config editor for a selected radio field in the rich-text editor. Uses the same compact toolbar
// layout as the external-PDF editor (RadioFieldToolbarControls), minus the font-size control (rich-text
// fields flow inline at a uniform size). The field config lives on the Slate node (`node.field`); edits
// are written back with Transforms.setNodes, which updates the document value → re-derives the field map
// → re-renders the radio.
export const RichTextRadioToolbar: React.FC<{
  editor: CustomEditor
  field: DropdownField
  path: Path
}> = ({ editor, field, path }) => {
  const options = useMemo<DropdownOptionItem[]>(
    () => (field.options ?? []).filter(isDropdownOptionItem),
    [field],
  )
  const direction = field.radioDirection ?? 'row'

  const updateField = useCallback(
    (patch: Partial<DropdownField>) => {
      Transforms.setNodes<TemplateFieldElement>(
        editor,
        { field: { ...field, ...patch } },
        { at: path, match: n => n.type === 'field' },
      )
    },
    [editor, field, path],
  )

  return (
    <RadioFieldToolbarControls
      direction={direction}
      onDirectionChange={radioDirection => updateField({ radioDirection })}
      options={options}
      onOptionsChange={newOptions => updateField({ options: newOptions })}
    />
  )
}
